import { uiFormat, uiText } from '../../i18n';
import { StudioIcon } from '../studio/StudioIcon';
import { useScreenUpload } from './use-screen-upload';

export interface JsonObjectNeed {
  kind: string;
  label: string;
  of: string;
  tip: string;
  min: number;
  max: number;
}
/** Лоток фото предмета для JSON-ключа контракта `objects: {goods|food|place|pics: [UUID]}` (docs/59, 03-api §9.2):
    загрузки делает экран сам (use-screen-upload), порядок — порядок добавления, сверх предела не добавить. */
export function ReelsObjectsJson({
  need,
  ids,
  locked,
  rights,
  consent,
  onChange,
}: {
  need: JsonObjectNeed;
  ids: string[];
  locked: boolean;
  rights: boolean;
  consent?: React.ReactNode;
  onChange(ids: string[]): void;
}) {
  const up = useScreenUpload();
  const free = Math.max(0, need.max - ids.length);
  const blocked = locked || !rights || !free || up.busy;
  async function add(files: FileList | null) {
    if (!files) return;
    let next = ids;
    for (const file of Array.from(files).slice(0, free)) {
      const id = await up.upload(file, 'photo');
      if (!id) break;
      next = [...next, id];
      onChange(next);
    }
  }
  return (
    <fieldset className="studio-photo-tray studio-native-upload rl-tray">
      <legend>
        {uiText(need.label)} · {ids.length ? uiFormat('{0} из {1}', Math.min(ids.length, need.max), need.max) : need.min === need.max ? String(need.min) : uiFormat('до {0}', need.max)}
      </legend>
      <div className="rl-grid">
        {ids.map((id, index) => (
          <div key={id} className={`rl-t ph${index >= need.max ? ' over' : ''}`}>
            <span className="mono">{uiFormat('Фото {0}', index + 1)}</span>
            <button type="button" className="x" disabled={locked} aria-label={uiFormat('Убрать фото {0}', index + 1)} onClick={() => onChange(ids.filter(x => x !== id))}>
              <StudioIcon kind="close" />
            </button>
          </div>
        ))}
        {free > 0 && (
          <label className="rl-t add">
            <input
              className="studio-native-file-input"
              type="file"
              accept="image/jpeg,image/png,image/webp"
              multiple={need.max > 1}
              disabled={blocked}
              aria-label={uiText('Загрузить фото')}
              onChange={event => {
                void add(event.target.files);
                event.target.value = '';
              }}
            />
            <StudioIcon kind="plus" />
            <small>{uiText(ids.length ? 'Добавить' : 'Загрузить')}</small>
          </label>
        )}
      </div>
      {up.busy && <p role="status">{uiText('Загружаем фото…')}</p>}
      {up.error && (
        <p role="alert">
          {uiText(up.error)}{' '}
          {up.pending && (
            <button
              type="button"
              onClick={async () => {
                const id = await up.check();
                if (id) onChange([...ids, id]);
              }}
            >
              {uiText('Проверить загрузку')}
            </button>
          )}
        </p>
      )}
      <p className="rl-tip">{uiText(ids.length > need.max ? uiFormat('В рилс войдут первые {0} фото', need.max) : need.tip)}</p>
      {consent}
    </fieldset>
  );
}
